import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useRef, useState } from 'react';
import { useDrag, useDrop } from 'react-dnd';
import uuid from 'uuid';
import DndTypes from '../../../types/DndTypes';
import { EDITOR_CREATE_IMAGE_GALLERY } from '../../../types/AnalyticsTypes';
import VerticalDragLine from './VerticalDragLine';

function getOverPosition(_ref, _ref2) {
  var x = _ref.x;
  var element = _ref2.current;

  var _element$getBoundingC = element.getBoundingClientRect(),
      left = _element$getBoundingC.left,
      width = _element$getBoundingC.width;

  return x < left + width / 2 ? 'before' : 'after';
}

export default function GalleryImage(_ref3) {
  var editor = _ref3.editor,
      node = _ref3.node,
      style = _ref3.style,
      canDrop = _ref3.canDrop,
      onLoad = _ref3.onLoad,
      onChildrenDragged = _ref3.onChildrenDragged,
      store = _ref3.store,
      children = _ref3.children;
  var ref = useRef(null);

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      linePosition = _useState2[0],
      setLinePosition = _useState2[1];

  var _useDrop = useDrop({
    accept: DndTypes.IMAGE_GALLERY,
    collect: function collect(monitor) {
      return {
        isDropHover: monitor.isOver({
          shallow: true
        })
      };
    },
    hover: function hover(item, monitor, dunno) {
      if (!canDrop || !ref) return;
      var position = getOverPosition(monitor.getClientOffset(), ref);
      setLinePosition(position);
    },
    drop: function drop(dragNode, monitor) {
      var position = getOverPosition(monitor.getClientOffset(), ref);

      var callback = function callback() {
        var galleryId = node.data.get('galleryId');
        editor.command('track', EDITOR_CREATE_IMAGE_GALLERY);

        var _editor$value$documen = editor.value.document.getNode(dragNode.key),
            data = _editor$value$documen.data;

        editor.setNodeByKey(dragNode.key, {
          data: data.set('galleryId', galleryId)
        });
      };

      return {
        dragNode: {
          key: dragNode.key
        },
        dropNode: {
          key: node.key
        },
        position: position,
        callback: callback
      };
    }
  }),
      _useDrop2 = _slicedToArray(_useDrop, 2),
      isDropHover = _useDrop2[0].isDropHover,
      dropRef = _useDrop2[1];

  var _useDrag = useDrag({
    item: {
      key: node.key,
      type: DndTypes.IMAGE_GALLERY
    },
    begin: function begin() {
      onChildrenDragged(true);
      store.isDraggingNode = true;
    },
    end: function end(item, monitor) {
      var dropResult = monitor.getDropResult();

      if (!dropResult || !dropResult.callback) {
        editor.setNodeByKey(node.key, {
          data: node.data.set('galleryId', uuid())
        });
      }

      onChildrenDragged(false);
      store.isDraggingNode = false;
    }
  }),
      _useDrag2 = _slicedToArray(_useDrag, 2),
      dragRef = _useDrag2[1];

  return React.createElement("div", {
    ref: dropRef(dragRef(ref)),
    className: "gallery-image-drop-wrapper",
    style: style,
    onLoad: onLoad
  }, isDropHover && React.createElement(VerticalDragLine, {
    position: linePosition
  }), children);
}